import { Box, List, ListItem, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface Props {
  services: string[]
  collapsed: boolean
}

export const PlanServices = ({ services, collapsed }: Props) => {
  const { t } = useTranslation()

  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="body2">
        {t('planCard.servicesAmount', { count: services.length })}
      </Typography>
      {!collapsed && (
        <List
          sx={{
            listStyleType: 'disc',
            pl: 3,
            pt: 2,
            '& .MuiListItem-root': {
              display: 'list-item',
            },
          }}
        >
          {services.map((s: string) => (
            <ListItem key={s} sx={{ pl: 0, py: 0 }}>
              <Typography variant="body2">{s}</Typography>
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  )
}
